// import Drawcanvas from './drawReportCanvas'
import NibutMapDraw from "../js/reportmapdraw";
import ButMapDraw from "../js/reportmapdrawForBut";
class CalcReportDate {
  constructor() {
    this.reportData = {};
  }
  meibomianLevelCal(loss) {
    loss = loss === 0 ? 0 : loss > 0 && loss <= 33 ? 1 : loss > 33 && loss <= 66 ? 2 : 3;
    return loss;
  }
  meibomianGlandGradeScore(loss) {
    loss = loss >= 0 && loss <= 1 ? 0 : loss > 1 && loss <= 3 ? 1 : loss > 3 && loss <= 5 ? 2 : 3;
    return loss;
  }
  getMediafile(photos, flag) {
    const { serverip, serverport, sslport, serverssl } = window.server || {};
    for (let id = 0; id < photos.length; id++) {
      if (photos[id].imagelabel === flag) {
        if (photos[id].filename) {
          return serverssl === 1
            ? `https://${serverip}:${sslport}/media/${photos[id].filename}?access_token=${window.token}`
            : `http://${serverip}:${serverport}/media/${photos[id].filename}?access_token=${window.token}`;
          // return serverssl === 1 ? `https://${serverip}:${sslport}/media/${photos[id].filename}_th.jpg?access_token=${window.token}` : `http://${serverip}:${serverport}/media/${photos[id].filename}_th.jpg?access_token=${window.token}`
        }
      }
    }
  }
  selectLevel(level) {
    let resulte = "--";
    let stdLevel = ["--", "txtNormal", "txtMild", "txtModerate", "txtSevere"];
    resulte = level !== "--" ? stdLevel[level] : stdLevel[0];
    return resulte;
  }
  adjustEyeRednessIsNormal(level) {
    if (level === "--") {
      return "--";
    } else {
      if (level >= 2) {
        return "txtAbnormal";
      } else {
        return "txtNormal";
      }
    }
  }
  AUTOCALCVALUE(value) {
    if (value) {
      if (value === -1) {
        return "--";
      } else {
        // console.log('window.magecoe.tearheight', window.magecoe.tearheight)
        let deal = `${value * window.magecoe.tearheight}`;
        // console.log('AUTOCALCVALUEdeal', deal)
        deal = Number(deal);
        deal = deal.toFixed(2);
        return deal;
      }
    } else {
      return "--";
    }
  }
  dealWithData(mapData) {
    const LEN = mapData.length / 16;
    const LENCIR = 16;
    let mapDataNeeded = [];
    for (let i = 0; i < LEN; i++) {
      let data = [];
      for (let j = 0; j < LENCIR; j++) {
        data.push(mapData[j + LENCIR * i]);
      }
      mapDataNeeded.push(data);
    }
    return mapDataNeeded;
  }
  // 报告睑板腺图片样式设置
  getMeibomianPhoto() {
    let standard;
    if (window.printSettings.meibomainReportImgSet === 0) {
      standard = "print"; // 原图
    } else if (window.printSettings.meibomainReportImgSet === 1) {
      standard = "enhancePrint"; // 增强图
    } else if (window.printSettings.meibomainReportImgSet === 2) {
      standard = "contourPrint"; // 轮廓图
    }
    return standard;
  }
  dataHandle(recordInfo, Mode) {
    // 初始化reportData
    this.reportData = {
      // 报告生成数据结构,重要!!!
      TearHeight: {
        mediafile: "",
        tearHeight: -1,
        score: 100,
        resulte: "",
        exist: true
      },
      NIBUT: {
        mediafile: "", // 图片显示
        url: "",
        averageTime: "--", // 结果显示
        firstTime: "--", // 结果显示
        Level: 0, // 等级换算
        resulte: "",
        score: 100, // 得分 0~100,
        exist: true
      },
      LipidLayer: {
        Level: 4,
        score: 100,
        resulte: "",
        exist: true
      },
      MeiBomian: {
        mediafile1: "", // 媒体文件名
        mediafile2: "",
        mediafile3: "",
        glandLoss: -1, // 报告结果显示
        Level: -1,
        resulte: "",
        score: 100,
        exist: true
      },
      EyelidEdge: {
        mediafile1: "", // 媒体文件名
        mediafile2: "",
        Level: -1,
        Levelup: -1,
        LevelDown: -1,
        resulte: "",
        score: 100,
        note: "",
        exist: true
      },
      EyeRedness: {
        mediafile: "",
        Level: "--",
        CiliaryLevel: "--",
        resulte: "",
        score: 100,
        note: "",
        exist: true
      },
      But: {
        // 新增but
        mediafile: "", // 图片显示
        url: "",
        averageTime: "--", // 结果显示
        firstTime: "--", // 结果显示
        Level: 0, // 等级换算
        resulte: "",
        score: 100, // 得分 0~100,
        exist: true
      },
      Blink: {
        NumNocmpltBlk: 0, // 不完全眨眼次数
        NumCmpltBlk: 0, // 完全眨眼次数
        NumTotalBlk: 0, // 总眨眼次数
        IBI: 0, // 总眨眼间隔
        RatioNocmpltBlk: 0, // 不完全眨眼比例
        CmpltBlkInv: 0, // 完全眨眼间隔, OPI的分母
        exist: true
      },
      Opi: {
        score: 100,
        resulte: "",
        exist: true
      },
      EyeSurface: {
        mediafile: "", // 媒体文件名
        note: "",
        exist: true
      },
      realData: false
    };
    // Meibomian数据处理
    if (
      recordInfo.meibomian &&
      recordInfo.meibomian.diagnosed &&
      window.printSettings.dryeye.meibomian
    ) {
      if (recordInfo.meibomian.down !== undefined && recordInfo.meibomian.up !== undefined) {
        if (recordInfo.meibomian.down.level >= 0 && recordInfo.meibomian.up.level >= 0) {
          let uplevel = recordInfo.meibomian.up.level;
          let downlevel = recordInfo.meibomian.down.level;
          this.reportData.MeiBomian.Level = this.meibomianGlandGradeScore(uplevel + downlevel);
          this.reportData.MeiBomian.UpLevel = uplevel;
          this.reportData.MeiBomian.DownLevel = downlevel;
        } else if (recordInfo.meibomian.down.level >= 0) {
          let uplevel = this.meibomianLevelCal(recordInfo.meibomian.up.glandloss * 100);
          let downlevel = recordInfo.meibomian.down.level;
          this.reportData.MeiBomian.Level = this.meibomianGlandGradeScore(uplevel + downlevel);
          this.reportData.MeiBomian.UpLevel = uplevel;
          this.reportData.MeiBomian.DownLevel = downlevel;
        } else if (recordInfo.meibomian.up.level >= 0) {
          let uplevel = recordInfo.meibomian.up.level;
          let downlevel = this.meibomianLevelCal(recordInfo.meibomian.down.glandloss * 100);
          this.reportData.MeiBomian.Level = this.meibomianGlandGradeScore(uplevel + downlevel);
          this.reportData.MeiBomian.UpLevel = uplevel;
          this.reportData.MeiBomian.DownLevel = downlevel;
        } else {
          let uplevel = this.meibomianLevelCal(recordInfo.meibomian.up.glandloss * 100);
          let downlevel = this.meibomianLevelCal(recordInfo.meibomian.down.glandloss * 100);
          this.reportData.MeiBomian.Level = this.meibomianGlandGradeScore(uplevel + downlevel);
          this.reportData.MeiBomian.UpLevel = uplevel;
          this.reportData.MeiBomian.DownLevel = downlevel;
        }
        this.reportData.MeiBomian.UpGlandloss =
          recordInfo.meibomian.up.glandloss >= 0
            ? Math.floor(recordInfo.meibomian.up.glandloss * 100) + "%"
            : 0 + "%";
        this.reportData.MeiBomian.DownGlandloss =
          recordInfo.meibomian.down.glandloss >= 0
            ? Math.floor(recordInfo.meibomian.down.glandloss * 100) + "%"
            : 0 + "%";
        this.reportData.MeiBomian.UpGlandpercent =
          recordInfo.meibomian.up.glandpercent >= 0
            ? Math.floor(recordInfo.meibomian.up.glandpercent * 100) + "%"
            : 0 + "%";
        this.reportData.MeiBomian.DownGlandpercent =
          recordInfo.meibomian.down.glandpercent >= 0
            ? Math.floor(recordInfo.meibomian.down.glandpercent * 100) + "%"
            : 0 + "%";
        this.reportData.MeiBomian.score =
          this.reportData.MeiBomian.Level === 0
            ? 100
            : this.reportData.MeiBomian.Level === 1
              ? 66
              : this.reportData.MeiBomian.Level === 2
                ? 33
                : 0;
        if (recordInfo.meibomian.down.photos && recordInfo.meibomian.down.photos.length > 0) {
          for (let id in recordInfo.meibomian.down.photos) {
            if (recordInfo.meibomian.down.photos[id].imagelabel === "enhancePrint") {
              this.reportData.MeiBomian.mediafile2 = this.getMediafile(
                recordInfo.meibomian.down.photos,
                this.getMeibomianPhoto()
              );
            }
          }
        }
        if (recordInfo.meibomian.up.photos && recordInfo.meibomian.up.photos.length > 0) {
          for (let id in recordInfo.meibomian.up.photos) {
            if (recordInfo.meibomian.up.photos[id].imagelabel === "enhancePrint") {
              this.reportData.MeiBomian.mediafile1 = this.getMediafile(
                recordInfo.meibomian.up.photos,
                this.getMeibomianPhoto()
              );
            }
          }
        }
      } else if (recordInfo.meibomian.down !== undefined || recordInfo.meibomian.up !== undefined) {
        if (recordInfo.meibomian.down !== undefined) {
          if (recordInfo.meibomian.down.level >= 0) {
            let downlevel = recordInfo.meibomian.down.level;
            this.reportData.MeiBomian.Level = downlevel;
            this.reportData.MeiBomian.DownLevel = downlevel;
          } else {
            let downlevel = this.meibomianLevelCal(recordInfo.meibomian.down.glandloss * 100);
            this.reportData.MeiBomian.Level = downlevel;
            this.reportData.MeiBomian.DownLevel = downlevel;
          }
          this.reportData.MeiBomian.DownGlandloss =
            recordInfo.meibomian.down.glandloss >= 0
              ? Math.floor(recordInfo.meibomian.down.glandloss * 100) + "%"
              : 0 + "%";
          this.reportData.MeiBomian.DownGlandpercent =
            recordInfo.meibomian.down.glandpercent >= 0
              ? Math.floor(recordInfo.meibomian.down.glandpercent * 100) + "%"
              : 0 + "%";
          this.reportData.MeiBomian.score =
            this.reportData.MeiBomian.Level === 0
              ? 0
              : this.reportData.MeiBomian.Level === 1
                ? 33
                : this.reportData.MeiBomian.Level === 2
                  ? 66
                  : 100;
          if (recordInfo.meibomian.down.photos && recordInfo.meibomian.down.photos.length > 0) {
            for (let id in recordInfo.meibomian.down.photos) {
              if (recordInfo.meibomian.down.photos[id].imagelabel === "enhancePrint") {
                this.reportData.MeiBomian.mediafile2 = this.getMediafile(
                  recordInfo.meibomian.down.photos,
                  this.getMeibomianPhoto()
                );
                break;
              }
            }
          }
        } else if (recordInfo.meibomian.up !== undefined) {
          if (recordInfo.meibomian.up.level >= 0) {
            let uplevel = recordInfo.meibomian.up.level;
            this.reportData.MeiBomian.Level = uplevel;
            this.reportData.MeiBomian.UpLevel = uplevel;
          } else {
            let uplevel = this.meibomianLevelCal(recordInfo.meibomian.up.glandloss * 100);
            this.reportData.MeiBomian.Level = uplevel;
            this.reportData.MeiBomian.UpLevel = uplevel;
          }
          this.reportData.MeiBomian.UpGlandloss =
            recordInfo.meibomian.up.glandloss >= 0
              ? Math.floor(recordInfo.meibomian.up.glandloss * 100) + "%"
              : 0 + "%";
          this.reportData.MeiBomian.UpGlandpercent =
            recordInfo.meibomian.up.glandpercent >= 0
              ? Math.floor(recordInfo.meibomian.up.glandpercent * 100) + "%"
              : 0 + "%";
          this.reportData.MeiBomian.score =
            this.reportData.MeiBomian.Level === 0
              ? 0
              : this.reportData.MeiBomian.Level === 1
                ? 33
                : this.reportData.MeiBomian.Level === 2
                  ? 66
                  : 100;
          if (recordInfo.meibomian.up.photos && recordInfo.meibomian.up.photos.length > 0) {
            for (let id in recordInfo.meibomian.up.photos) {
              if (recordInfo.meibomian.up.photos[id].imagelabel === "enhancePrint") {
                this.reportData.MeiBomian.mediafile1 = this.getMediafile(
                  recordInfo.meibomian.up.photos,
                  this.getMeibomianPhoto()
                );
                break;
              }
            }
          }
        }
      }
    } else {
      this.reportData.MeiBomian.exist = false;
    }
    // 泪河高度数据处理
    if (
      recordInfo.tearheight &&
      recordInfo.tearheight.diagnosed &&
      window.printSettings.dryeye.tearheight
    ) {
      let height = null;
      if (
        (recordInfo.tearheight.clonetrensdDataYHeigth === -1 ||
          recordInfo.tearheight.clonetrensdDataYHeigth === "--") &&
        recordInfo.tearheight.trensdDataYHeigth === null &&
        recordInfo.tearheight.manualMeasureAvg === 0
      ) {
        height = "--";
        this.reportData.TearHeight.height = height;
        this.reportData.TearHeight.exist = false;
      }
      if (!this.reportData.TearHeight.height) {
        if (!recordInfo.tearheight.manualMeasureAvg) {
          height = recordInfo.tearheight.clonetrensdDataYHeigth * window.magecoe.tearheight;
        } else {
          height = recordInfo.tearheight.manualMeasureAvg;
        }
        if (typeof height === "string") {
          height = Number(height);
        }
        this.reportData.TearHeight.height = height.toFixed(2);
      } else {
        height = "--";
      }
      // 有争议
      // this.reportData.TearHeight.height = height === -1 ? '--' : height.toFixed(2)
      if (height === "--") {
        this.reportData.TearHeight.score = 100;
      } else {
        this.reportData.TearHeight.score =
          Math.round((height / 5) * 1000) > 100 ? 100 : Math.round((height / 5) * 1000);
      }
      if (this.reportData.TearHeight.height !== "--") {
        this.reportData.TearHeight.resulte =
          this.reportData.TearHeight.height >= 0.2 ? "txtNormal" : "txtAbnormal";
      }
      if (recordInfo.tearheight.photos.length > 0) {
        if (this.getMediafile(recordInfo.tearheight.photos, "print")) {
          this.reportData.TearHeight.mediafile = this.getMediafile(
            recordInfo.tearheight.photos,
            "print"
          );
        } else {
          this.reportData.TearHeight.mediafile = this.getMediafile(
            recordInfo.tearheight.photos,
            "original"
          );
          // this.reportData.TearHeight.exist = false
        }
      }
    } else {
      this.reportData.TearHeight.exist = false;
    }
    // 眼红计算
    if (
      recordInfo.eyeredness &&
      recordInfo.eyeredness.diagnosed &&
      window.printSettings.dryeye.eyeredness
    ) {
      function handleValue(val) {
        if (val === undefined || val === "") {
          return "--";
        } else if (val === -1 || val === -1000) {
          return "--";
        } else {
          return Math.floor(val * 1000) / 10 + "%";
        }
      }
      this.reportData.EyeRedness.nasalciliary = handleValue(recordInfo.eyeredness.nasalciliary);
      this.reportData.EyeRedness.tempciliary = handleValue(recordInfo.eyeredness.tempciliary);
      this.reportData.EyeRedness.nasalconjunctival = handleValue(
        recordInfo.eyeredness.nasalconjunctival
      );
      this.reportData.EyeRedness.tempconjunctival = handleValue(
        recordInfo.eyeredness.tempconjunctival
      );
      if (
        recordInfo.eyeredness.nasalciliary !== -1 ||
        recordInfo.eyeredness.tempciliary !== -1 ||
        recordInfo.eyeredness.nasalconjunctival !== -1 ||
        recordInfo.eyeredness.tempconjunctival !== -1
      ) {
        if (recordInfo.eyeredness.nasalciliary !== -1) {
          if (recordInfo.eyeredness.tempciliary !== -1) {
            this.reportData.EyeRedness.Level =
              parseFloat(recordInfo.eyeredness.nasalciliary) >
              parseFloat(recordInfo.eyeredness.tempciliary)
                ? parseFloat(recordInfo.eyeredness.nasalciliary)
                : parseFloat(recordInfo.eyeredness.tempciliary);
          } else {
            this.reportData.EyeRedness.Level = parseFloat(recordInfo.eyeredness.nasalciliary);
          }
        }
        if (recordInfo.eyeredness.nasalconjunctival !== -1) {
          if (recordInfo.eyeredness.tempconjunctival !== -1) {
            this.reportData.EyeRedness.CiliaryLevel =
              parseFloat(recordInfo.eyeredness.nasalconjunctival) >
              parseFloat(recordInfo.eyeredness.tempconjunctival)
                ? parseFloat(recordInfo.eyeredness.nasalconjunctival)
                : parseFloat(recordInfo.eyeredness.tempconjunctival);
          } else {
            this.reportData.EyeRedness.CiliaryLevel = parseFloat(
              recordInfo.eyeredness.nasalconjunctival
            );
          }
        }
        let EyeCiliaryLevel =
          this.reportData.EyeRedness.CiliaryLevel > 0
            ? Math.floor(this.reportData.EyeRedness.CiliaryLevel * 1000) / 10
            : "--";
        let EyeLevel =
          this.reportData.EyeRedness.Level > 0
            ? Math.floor(this.reportData.EyeRedness.Level * 1000) / 10
            : "--";
        let CiliaryLevel = this.adjustEyeRednessIsNormal(EyeCiliaryLevel);
        let Level = this.adjustEyeRednessIsNormal(EyeLevel);
        this.reportData.EyeRedness.Level =
          this.reportData.EyeRedness.Level > 0
            ? Math.floor(this.reportData.EyeRedness.Level * 1000) / 10 + "%"
            : "--";
        this.reportData.EyeRedness.CiliaryLevel =
          this.reportData.EyeRedness.CiliaryLevel > 0
            ? Math.floor(this.reportData.EyeRedness.CiliaryLevel * 1000) / 10 + "%"
            : "--";
        if (CiliaryLevel === "txtAbnormal" || Level === "txtAbnormal") {
          this.reportData.EyeRedness.resulte = "txtAbnormal";
        } else if (CiliaryLevel === "--" && Level === "--") {
          this.reportData.EyeRedness.resulte = "--";
        } else {
          this.reportData.EyeRedness.resulte = "txtNormal";
        }
        this.reportData.EyeRedness.note = recordInfo.eyeredness.note;
        if (EyeLevel !== -1) {
          this.reportData.EyeRedness.score = 100 - Math.round(EyeLevel);
        }

        if (this.getMediafile(recordInfo.eyeredness.photos, "print")) {
          // 不同情况的print图片，传回来的图片尺寸有大有小
          this.reportData.EyeRedness.mediafile = this.getMediafile(
            recordInfo.eyeredness.photos,
            "print"
          );
        } else {
          this.reportData.EyeRedness.mediafile = this.getMediafile(
            recordInfo.eyeredness.photos,
            "original"
          );
        }
      } else {
        // 眼红没有取到正常图片时下面彩虹条不显示
        this.reportData.EyeRedness.exist = false;
      }
    } else {
      this.reportData.EyeRedness.exist = false;
    }

    // NIBUT计算
    if (recordInfo.nibut && recordInfo.nibut.diagnosed && window.printSettings.dryeye.nibut) {
      if (recordInfo.nibut.usefultime !== undefined) {
        let height = Mode === "oldReport" ? 285 : 285;
        let width = Mode === "oldReport" ? 420 : 420;
        // let height = Mode === 'oldReport' ? 155 : 155
        // let width = Mode === 'oldReport' ? 296 : 296
        let mapData = this.dealWithData(recordInfo.nibut.rupturetimes);
        // let myNibutCir = new NibutMapDraw('', recordInfo.nibut.rupturetimes.length, recordInfo.nibut.rupturetimes, {height: height, width: width, usefultime: recordInfo.nibut.usefultime, size: true})
        let myNibutCir = new NibutMapDraw("", mapData.length, mapData, {
          height: height,
          width: width,
          usefultime: recordInfo.nibut.usefultime,
          size: true
        });
        this.reportData.NIBUT.url = myNibutCir._canvas.toDataURL("image/png");
        if (
          recordInfo.nibut.firstrupturetime !== undefined &&
          recordInfo.nibut.avgruptruretime !== undefined
        ) {
          let ft =
            recordInfo.nibut.firstrupturetime === 0
              ? 0.04
              : parseFloat(Math.round(recordInfo.nibut.firstrupturetime));
          let at =
            recordInfo.nibut.avgruptruretime === 0
              ? 0.04
              : parseFloat(Math.round(recordInfo.nibut.avgruptruretime));
          let result =
            typeof recordInfo.nibut.usefultime === "string"
              ? parseFloat(recordInfo.nibut.usefultime)
              : recordInfo.nibut.usefultime;
          this.reportData.NIBUT.firstTime = ft === 10000 ? result.toFixed(2) : ft;
          this.reportData.NIBUT.averageTime = at === 10000 ? result.toFixed(2) : at;
          this.reportData.NIBUT.score =
            Math.floor((at / 21) * 10000) / 100 > 100 ? 100 : Math.floor((at / 21) * 10000) / 100;
          if (recordInfo.nibut.avgruptruretime >= 14) {
            this.reportData.NIBUT.Level = 0;
            this.reportData.NIBUT.resulte = "txtNormal";
          } else if (at < 14 && at > 7) {
            this.reportData.NIBUT.Level = 1;
            this.reportData.NIBUT.resulte = "txtCritical";
          } else if (at <= 7) {
            this.reportData.NIBUT.Level = 2;
            this.reportData.NIBUT.resulte = "txtDryEye";
          }
          let result1 =
            typeof recordInfo.nibut.usefultime === "string"
              ? parseFloat(recordInfo.nibut.usefultime)
              : recordInfo.nibut.usefultime;
          recordInfo.nibut.usefultime =
            result1.usefultime !== 0 && result1 ? result1.toFixed(2) : 0;
          if ((ft === 10000.0 || ft === 10000) && recordInfo.nibut.usefultime <= 14) {
            this.reportData.NIBUT.Level = 0;
            this.reportData.NIBUT.resulte = "txtUnbroken";
            this.reportData.NIBUT.firstTime = recordInfo.nibut.usefultime
              ? `>${recordInfo.nibut.usefultime}`
              : `>${Number(recordInfo.nibut.totaltime.toFixed(2))}`;
            this.reportData.NIBUT.averageTime = recordInfo.nibut.usefultime
              ? `>${recordInfo.nibut.usefultime}`
              : `>${Number(recordInfo.nibut.totaltime.toFixed(2))}`;
          } else if (ft === 10000.0 || ft === 10000) {
            this.reportData.NIBUT.Level = 0;
            this.reportData.NIBUT.resulte = "txtNormal";
            this.reportData.NIBUT.firstTime = recordInfo.nibut.usefultime
              ? `>${recordInfo.nibut.usefultime}`
              : `>${Number(recordInfo.nibut.totaltime.toFixed(2))}`;
            this.reportData.NIBUT.averageTime = recordInfo.nibut.usefultime
              ? `>${recordInfo.nibut.usefultime}`
              : `>${Number(recordInfo.nibut.totaltime.toFixed(2))}`;
          }
        }
      } else {
        this.reportData.NIBUT.exist = false;
      }
    } else {
      this.reportData.NIBUT.exist = false;
    }

    // But打印报告数据
    if (
      recordInfo.fbut &&
      ((recordInfo.fbut.length > 1 &&
        recordInfo.fbut[0].diagnosed &&
        recordInfo.fbut[1].diagnosed &&
        recordInfo.fbut[2].diagnosed) ||
        recordInfo.fbut[0].diagnosed) &&
      window.printSettings.dryeye.fbut
    ) {
      if (
        recordInfo.fbut.length > 1 &&
        recordInfo.fbut[0].usefultime !== undefined &&
        recordInfo.fbut[1].usefultime !== undefined &&
        recordInfo.fbut[2].usefultime !== undefined
      ) {
        // let height = Mode === 'oldReport' ? 285 : 285
        // let width = Mode === 'oldReport' ? 420 : 420
        // let mapData = this.dealWithData(recordInfo.fbut[index].rupturetimes)
        // let myNibutCir = new NibutMapDraw('', recordInfo.nibut.rupturetimes.length, recordInfo.nibut.rupturetimes, {height: height, width: width, usefultime: recordInfo.nibut.usefultime, size: true})
        // let myNibutCir = new ButMapDraw('', mapData.length, mapData, { height: height, width: width, usefultime: recordInfo.fbut[index].usefultime, size: true })
        // this.reportData.But.url = myNibutCir._canvas.toDataURL('image/png')
        if (
          recordInfo.fbut[0].firstrupturetime !== undefined &&
          recordInfo.fbut[1].firstrupturetime !== undefined &&
          recordInfo.fbut[2].firstrupturetime !== undefined
        ) {
          let ftOne =
            recordInfo.fbut[0].firstrupturetime === 0
              ? 0.04
              : parseFloat(recordInfo.fbut[0].firstrupturetime.toFixed(2));
          let ftTwo =
            recordInfo.fbut[1].firstrupturetime === 0
              ? 0.04
              : parseFloat(recordInfo.fbut[1].firstrupturetime.toFixed(2));
          let ftThree =
            recordInfo.fbut[2].firstrupturetime === 0
              ? 0.04
              : parseFloat(recordInfo.fbut[2].firstrupturetime.toFixed(2));
          ftOne =
            ftOne === 10000
              ? (recordInfo.fbut[0].usefultime
                  ? recordInfo.fbut[0].usefultime
                  : recordInfo.fbut[0].totaltime
                ).toFixed(2)
              : ftOne;
          ftTwo =
            ftTwo === 10000
              ? (recordInfo.fbut[1].usefultime
                  ? recordInfo.fbut[1].usefultime
                  : recordInfo.fbut[1].totaltime
                ).toFixed(2)
              : ftTwo;
          ftThree =
            ftThree === 10000
              ? (recordInfo.fbut[2].usefultime
                  ? recordInfo.fbut[2].usefultime
                  : recordInfo.fbut[2].totaltime
                ).toFixed(2)
              : ftThree;
          let ftAnd = ((Number(ftOne) + Number(ftTwo) + Number(ftThree)) / 3).toFixed(2);
          this.reportData.But.firstTime = Number(ftAnd);
          this.reportData.But.score =
            Math.floor((this.reportData.But.firstTime / 10) * 10000) / 100 > 100
              ? 100
              : Math.floor((this.reportData.But.firstTime / 10) * 10000) / 100;
          if (this.reportData.But.firstTime > 10) {
            this.reportData.But.Level = 0;
            this.reportData.But.resulte = "txtNormal";
          } else if (this.reportData.But.firstTime <= 10 && this.reportData.But.firstTime > 5) {
            this.reportData.But.Level = 1;
            this.reportData.But.resulte = "txtMild";
          } else if (this.reportData.But.firstTime <= 5 && this.reportData.But.firstTime >= 2) {
            this.reportData.But.Level = 2;
            this.reportData.But.resulte = "txtModerate";
          } else if (this.reportData.But.firstTime < 2) {
            this.reportData.But.Level = 3;
            this.reportData.But.resulte = "txtSevere";
          } else {
            this.reportData.But.Level = 4;
            this.reportData.But.resulte = "txtNoIntactTearFilm";
          }
          // recordInfo.but.usefultime = recordInfo.but.usefultime !== 0 ? recordInfo.but.usefultime.toFixed(2) : 0
          // if ((ft === 10000.00 || ft === 10000) && recordInfo.but.usefultime <= 13) {
          //   this.reportData.But.Level = 0
          //   this.reportData.But.resulte = 'txtUnbroken'
          //   this.reportData.But.firstTime = `>${(recordInfo.but.usefultime)}`
          //   this.reportData.But.averageTime = `>${(recordInfo.but.usefultime)}`
          // } else if ((ft === 10000.00 || ft === 10000)) {
          //   this.reportData.But.Level = 0
          //   this.reportData.But.resulte = 'txtNormal'
          //   this.reportData.But.firstTime = `>${(recordInfo.but.usefultime)}`
          //   this.reportData.But.averageTime = `>${(recordInfo.but.usefultime)}`
          // }
        }
      } else if (recordInfo.fbut.length == 1 && recordInfo.fbut[0].usefultime !== undefined) {
        if (recordInfo.fbut[0].firstrupturetime !== undefined) {
          let ftOne =
            recordInfo.fbut[0].firstrupturetime === 0
              ? 0.04
              : parseFloat(recordInfo.fbut[0].firstrupturetime.toFixed(2));
          ftOne =
            ftOne === 10000
              ? (recordInfo.fbut[0].usefultime
                  ? recordInfo.fbut[0].usefultime
                  : recordInfo.fbut[0].totaltime
                ).toFixed(2)
              : ftOne;
          this.reportData.But.firstTime = Number(ftOne);
          this.reportData.But.score =
            Math.floor((this.reportData.But.firstTime / 10) * 10000) / 100 > 100
              ? 100
              : Math.floor((this.reportData.But.firstTime / 10) * 10000) / 100;
          if (this.reportData.But.firstTime > 10) {
            this.reportData.But.Level = 0;
            this.reportData.But.resulte = "txtNormal";
          } else if (this.reportData.But.firstTime <= 10 && this.reportData.But.firstTime > 5) {
            this.reportData.But.Level = 1;
            this.reportData.But.resulte = "txtMild";
          } else if (this.reportData.But.firstTime <= 5 && this.reportData.But.firstTime >= 2) {
            this.reportData.But.Level = 2;
            this.reportData.But.resulte = "txtModerate";
          } else if (this.reportData.But.firstTime < 2) {
            this.reportData.But.Level = 3;
            this.reportData.But.resulte = "txtSevere";
          } else {
            this.reportData.But.Level = 4;
            this.reportData.But.resulte = "txtNoIntactTearFilm";
          }
        }
      } else {
        this.reportData.But.exist = false;
      }
    } else {
      this.reportData.But.exist = false;
    }

    // 眨眼质量打印报告数据
    if (recordInfo.blink && recordInfo.blink.diagnosed && window.printSettings.dryeye.blink) {
      if (
        recordInfo.blink.NumNocmpltBlk !== undefined ||
        recordInfo.blink.NumCmpltBlk !== undefined ||
        recordInfo.blink.NumTotalBlk !== undefined ||
        recordInfo.blink.videoTime !== undefined ||
        recordInfo.blink.RatioNocmpltBlk !== undefined ||
        recordInfo.blink.CmpltBlkInv !== undefined
      ) {
        this.reportData.Blink.NumNocmpltBlk = recordInfo.blink.NumNocmpltBlk.toFixed();
        this.reportData.Blink.NumCmpltBlk = recordInfo.blink.NumCmpltBlk.toFixed();
        this.reportData.Blink.NumTotalBlk = recordInfo.blink.NumTotalBlk.toFixed();
        this.reportData.Blink.IBI =
          recordInfo.blink.videoTime && this.reportData.Blink.NumTotalBlk !== "0"
            ? (recordInfo.blink.videoTime / this.reportData.Blink.NumTotalBlk).toFixed(1)
            : 0;
        this.reportData.Blink.RatioNocmpltBlk = recordInfo.blink.RatioNocmpltBlk.toFixed();
        this.reportData.Blink.CmpltBlkInv = recordInfo.blink.CmpltBlkInv.toFixed(1);
      } else {
        this.reportData.Blink.exist = false;
      }
    } else {
      this.reportData.Blink.exist = false;
    }
    // OPI打印报告数据
    if (
      recordInfo.blink &&
      recordInfo.blink.diagnosed &&
      recordInfo.fbut &&
      ((recordInfo.fbut.length > 1 &&
        recordInfo.fbut[0].diagnosed &&
        recordInfo.fbut[1].diagnosed &&
        recordInfo.fbut[2].diagnosed) ||
        (recordInfo.fbut.length == 1 && recordInfo.fbut[0].diagnosed) ||
        (recordInfo.nibut && recordInfo.nibut.diagnosed)) &&
      (window.printSettings.dryeye.fbut || window.printSettings.dryeye.nibut) &&
      window.printSettings.dryeye.blink
    ) {
      if (
        window.printSettings.dryeye.fbut &&
        ((recordInfo.fbut.length > 1 &&
          recordInfo.fbut[0].firstrupturetime !== undefined &&
          recordInfo.fbut[1].firstrupturetime !== undefined &&
          recordInfo.fbut[2].firstrupturetime !== undefined &&
          recordInfo.blink.CmpltBlkInv !== undefined) ||
          (recordInfo.fbut.length == 1 && recordInfo.fbut[0].firstrupturetime !== undefined))
      ) {
        let averagenum = this.reportData.But.firstTime;
        let CmpltBlkInv = Number(recordInfo.blink.videoTime / recordInfo.blink.NumTotalBlk).toFixed(
          1
        );
        this.reportData.Opi.score =
          (averagenum / CmpltBlkInv).toFixed(2) * 100 > 100
            ? 100
            : (averagenum / CmpltBlkInv).toFixed(2) * 100;
        this.reportData.Opi.resulte = this.reportData.Opi.score >= 1 ? "txtNormal" : "txtAbnormal";
      } else if (
        window.printSettings.dryeye.nibut &&
        recordInfo.nibut.firstrupturetime !== undefined
      ) {
        let averagenum = this.reportData.NIBUT.firstTime;
        let CmpltBlkInv = Number(recordInfo.blink.videoTime / recordInfo.blink.NumTotalBlk).toFixed(
          1
        );
        this.reportData.Opi.score =
          (averagenum / CmpltBlkInv).toFixed(2) * 100 > 100
            ? 100
            : (averagenum / CmpltBlkInv).toFixed(2) * 100;
        this.reportData.Opi.resulte = this.reportData.Opi.score >= 1 ? "txtNormal" : "txtAbnormal";
      } else {
        this.reportData.Opi.exist = false;
      }
    } else {
      this.reportData.Opi.exist = false;
    }
    // 睑缘打印报告数据
    if (
      recordInfo.eyelidedge &&
      recordInfo.eyelidedge.diagnosed &&
      window.printSettings.dryeye.eyelidedge
    ) {
      if (recordInfo.eyelidedge.note) {
        this.reportData.EyelidEdge.note = recordInfo.eyelidedge.note;
      }
      if (recordInfo.eyelidedge.down && recordInfo.eyelidedge.up) {
        if (
          recordInfo.eyelidedge.down.level !== undefined &&
          recordInfo.eyelidedge.up.level !== undefined
        ) {
          if (recordInfo.eyelidedge.down.level !== -1 && recordInfo.eyelidedge.up.level !== -1) {
            this.reportData.EyelidEdge.LevelDown = recordInfo.eyelidedge.down.level;
            this.reportData.EyelidEdge.Levelup = recordInfo.eyelidedge.up.level;
            this.reportData.EyelidEdge.resulteDown = this.selectLevel(
              recordInfo.eyelidedge.down.level
            );
            this.reportData.EyelidEdge.resulteup = this.selectLevel(recordInfo.eyelidedge.up.level);
            let majorScore =
              recordInfo.eyelidedge.up.level > recordInfo.eyelidedge.down.level
                ? recordInfo.eyelidedge.up.level
                : recordInfo.eyelidedge.down.level;
            this.reportData.EyelidEdge.score =
              100 - (majorScore - 1) * 33 < 0 ? 0 : 100 - (majorScore - 1) * 33;
          } else if (recordInfo.eyelidedge.down.level !== -1) {
            this.reportData.EyelidEdge.LevelDown = recordInfo.eyelidedge.down.level;
            this.reportData.EyelidEdge.resulteDown = this.selectLevel(
              recordInfo.eyelidedge.down.level
            );
            this.reportData.EyelidEdge.Levelup = "--";
            this.reportData.EyelidEdge.resulteup = this.selectLevel("--");
            this.reportData.EyelidEdge.score =
              100 - (recordInfo.eyelidedge.down.level - 1) * 33 < 0
                ? 0
                : 100 - (recordInfo.eyelidedge.down.level - 1) * 33;
          } else if (recordInfo.eyelidedge.up.level !== -1) {
            this.reportData.EyelidEdge.Levelup = recordInfo.eyelidedge.up.level;
            this.reportData.EyelidEdge.resulteup = this.selectLevel(recordInfo.eyelidedge.up.level);
            this.reportData.EyelidEdge.LevelDown = "--";
            this.reportData.EyelidEdge.resulteDown = this.selectLevel("--");
            console.log(
              "eyelidedge::::",
              recordInfo.eyelidedge.up.level,
              this.reportData.EyelidEdge.resulteup
            );
            this.reportData.EyelidEdge.score =
              100 - (recordInfo.eyelidedge.up.level - 1) * 33 < 0
                ? 0
                : 100 - (recordInfo.eyelidedge.up.level - 1) * 33;
          } else {
            this.reportData.EyelidEdge.resulteDown = this.selectLevel("--");
            this.reportData.EyelidEdge.Levelup = "--";
            this.reportData.EyelidEdge.resulteDown = this.selectLevel("--");
            this.reportData.EyelidEdge.LevelDown = "--";
            this.reportData.EyelidEdge.exist = false;
            this.reportData.EyelidEdge.score = 0;
          }
        } else if (
          recordInfo.eyelidedge.down.level == undefined &&
          recordInfo.eyelidedge.up.level == undefined
        ) {
          this.reportData.EyelidEdge.resulteDown = this.selectLevel("--");
          this.reportData.EyelidEdge.Levelup = "--";
          this.reportData.EyelidEdge.resulteup = this.selectLevel("--");
          this.reportData.EyelidEdge.LevelDown = "--";
          this.reportData.EyelidEdge.score = "--";
        } else {
          if (recordInfo.eyelidedge.down.level === undefined) {
            this.reportData.EyelidEdge.LevelDown = "--";
            this.reportData.EyelidEdge.resulteDown = this.selectLevel("--");
            this.reportData.EyelidEdge.Levelup = recordInfo.eyelidedge.up.level;
            this.reportData.EyelidEdge.resulteup = this.selectLevel(recordInfo.eyelidedge.up.level);
            this.reportData.EyelidEdge.score =
              100 - (recordInfo.eyelidedge.up.level - 1) * 33 < 0
                ? 0
                : 100 - (recordInfo.eyelidedge.up.level - 1) * 33;
          } else if (recordInfo.eyelidedge.up.level === undefined) {
            this.reportData.EyelidEdge.Levelup = "--";
            this.reportData.EyelidEdge.resulteup = this.selectLevel("--");
            this.reportData.EyelidEdge.LevelDown = recordInfo.eyelidedge.up.level;
            this.reportData.EyelidEdge.resulteDown = this.selectLevel(
              recordInfo.eyelidedge.down.level
            );
            this.reportData.EyelidEdge.score =
              100 - (recordInfo.eyelidedge.down.level - 1) * 33 < 0
                ? 0
                : 100 - (recordInfo.eyelidedge.down.level - 1) * 33;
          }
        }
      } else if (recordInfo.eyelidedge.down) {
        if (recordInfo.eyelidedge.down.level !== undefined) {
          if (recordInfo.eyelidedge.down.level !== -1) {
            this.reportData.EyelidEdge.LevelDown = recordInfo.eyelidedge.down.level;
            this.reportData.EyelidEdge.resulteDown = this.selectLevel(
              recordInfo.eyelidedge.down.level
            );
            this.reportData.EyelidEdge.Levelup = "--";
            this.reportData.EyelidEdge.resulteup = this.selectLevel("--");
            this.reportData.EyelidEdge.score =
              100 - (recordInfo.eyelidedge.down.level - 1) * 33 < 0
                ? 0
                : 100 - (recordInfo.eyelidedge.down.level - 1) * 33;
          } else {
            this.reportData.EyelidEdge.resulteDown = this.selectLevel("--");
            this.reportData.EyelidEdge.Levelup = "--";
            this.reportData.EyelidEdge.resulteDown = this.selectLevel("--");
            this.reportData.EyelidEdge.LevelDown = "--";
            this.reportData.EyelidEdge.exist = false;
            this.reportData.EyelidEdge.score = 0;
          }
        }
      } else if (recordInfo.eyelidedge.up) {
        if (recordInfo.eyelidedge.up.level !== undefined) {
          if (recordInfo.eyelidedge.up.level !== -1) {
            this.reportData.EyelidEdge.Levelup = recordInfo.eyelidedge.up.level;
            this.reportData.EyelidEdge.resulteup = this.selectLevel(recordInfo.eyelidedge.up.level);
            this.reportData.EyelidEdge.LevelDown = "--";
            this.reportData.EyelidEdge.resulteDown = this.selectLevel("--");
            console.log(
              "eyelidedge::::",
              recordInfo.eyelidedge.up.level,
              this.reportData.EyelidEdge.resulteup
            );
            this.reportData.EyelidEdge.score =
              100 - (recordInfo.eyelidedge.up.level - 1) * 33 < 0
                ? 0
                : 100 - (recordInfo.eyelidedge.up.level - 1) * 33;
          } else {
            this.reportData.EyelidEdge.resulteDown = this.selectLevel("--");
            this.reportData.EyelidEdge.Levelup = "--";
            this.reportData.EyelidEdge.resulteDown = this.selectLevel("--");
            this.reportData.EyelidEdge.LevelDown = "--";
            this.reportData.EyelidEdge.exist = false;
            this.reportData.EyelidEdge.score = 0;
          }
        }
      } else {
        this.reportData.EyelidEdge.exist = false;
      }
      if (recordInfo.eyelidedge.down && recordInfo.eyelidedge.down.photos) {
        if (recordInfo.eyelidedge.down) {
          if (this.getMediafile(recordInfo.eyelidedge.down.photos, "print")) {
            this.reportData.EyelidEdge.mediafile2 = this.getMediafile(
              recordInfo.eyelidedge.down.photos,
              "print"
            );
          } else {
            this.reportData.EyelidEdge.mediafile2 = this.getMediafile(
              recordInfo.eyelidedge.down.photos,
              "original"
            );
            // 有疑问 可能拿不到print 图片 或者 尺寸问题
          }
        }
      }
      if (recordInfo.eyelidedge.up && recordInfo.eyelidedge.up.photos) {
        if (recordInfo.eyelidedge.up) {
          if (this.getMediafile(recordInfo.eyelidedge.up.photos, "print")) {
            this.reportData.EyelidEdge.mediafile1 = this.getMediafile(
              recordInfo.eyelidedge.up.photos,
              "print"
            );
          } else {
            this.reportData.EyelidEdge.mediafile1 = this.getMediafile(
              recordInfo.eyelidedge.up.photos,
              "original"
            );
            // 有疑问 可能拿不到print 图片 或者 尺寸问题
          }
        }
      }
    } else {
      this.reportData.EyelidEdge.exist = false;
    }

    // 眼表染色
    if (
      recordInfo.ocularsurface &&
      recordInfo.ocularsurface.diagnosed &&
      window.printSettings.dryeye.ocularsurface
    ) {
      this.reportData.EyeSurface.note = recordInfo.ocularsurface.note;
      if (this.getMediafile(recordInfo.ocularsurface.photos, "print")) {
        this.reportData.EyeSurface.mediafile = this.getMediafile(
          recordInfo.ocularsurface.photos,
          "print"
        );
      } else {
        this.reportData.EyeSurface.mediafile = this.getMediafile(
          recordInfo.ocularsurface.photos,
          "original"
        );
        // console.log('拿到的图片', recordInfo.ocularsurface.photos)
        // this.reportData.EyeSurface.exist = false
      }
    } else {
      this.reportData.EyeSurface.exist = false;
    }
    // 脂质层
    if (
      recordInfo.lipidlayer &&
      recordInfo.lipidlayer.diagnosed &&
      window.printSettings.dryeye.lipidlayer
    ) {
      // console.log('脂质层数据查看', recordInfo.lipidlayer)
      this.reportData.LipidLayer.Level =
        recordInfo.lipidlayer.level === -1 ? 4 : recordInfo.lipidlayer.level;
      this.reportData.LipidLayer.score = Math.round(this.reportData.LipidLayer.Level * 25);
      this.reportData.LipidLayer.resulte =
        this.reportData.LipidLayer.Level >= 3 ? "txtNormal" : "txtAbnormal";
      if (this.getMediafile(recordInfo.lipidlayer.photos, "original")) {
        this.reportData.LipidLayer.mediafile = this.getMediafile(
          recordInfo.lipidlayer.photos,
          "original"
        );
      } else {
        this.reportData.LipidLayer.mediafile = "";
      }
    } else {
      this.reportData.LipidLayer.exist = false;
    }
    return this.reportData;
  }
}
export default CalcReportDate;



// WEBPACK FOOTER //
// ./src/dryeye/js/reportDataHanld.js